import React from 'react';
import PropTypes from 'prop-types';
import CaretIcon from '../../../shared/icons/icon-caret.svg';
import BackArrowIcon from '../../../shared/icons/icon-back-arrow.svg';
import CustomReactMarkdown from '../../../shared/components/MarkdownRenderers/CustomReactMarkdown';


const uuid = require('uuid/v4');


const NavPane = function NavPaneComponent({
  activePane,
  backItemId,
  displayName,
  paneId,
  goToNavPane,
  navItems,
  goToRoot,
}) {
  const backHandler = goToRoot || goToNavPane;

  return activePane === paneId && (
    <>
      <li
        key={uuid()}
        className="nav-drawer__link-list__item"
      >
        <div
          role="button"
          tabIndex="0"
          className="nav-drawer__link-back"
          onClick={() => backHandler(backItemId)}
          onKeyPress={() => backHandler(backItemId)}
        >
          <BackArrowIcon className="nav-drawer__arrow" />
          <span>{displayName}</span>
        </div>
      </li>

      {navItems.map((item) => {
        if (item.items) {
          return (
            <li
              key={uuid()}
              className="nav-drawer__link-list__item"
            >
              <div
                role="button"
                tabIndex="0"
                className="nav-drawer__link"
                onClick={() => goToNavPane(`${backItemId}_subGroups_${item.name}`)}
                onKeyPress={() => goToNavPane(`${backItemId}_subGroups_${item.name}`)}
              >
                <span>{item.name}</span>
                <CaretIcon className="nav-drawer__caret" />
              </div>
            </li>
          );
        }

        return (
          <li
            key={uuid()}
            className="nav-drawer__link-list__item"
          >
            <CustomReactMarkdown
              className="nav-drawer__link-markdown"
              source={item}
            />
          </li>
        );
      })}
    </>
  );
};

NavPane.propTypes = {
  activePane: PropTypes.string,
  goToRoot: PropTypes.func,
  paneId: PropTypes.string.isRequired,
  backItemId: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  navItems: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({}),
  ])).isRequired,
  goToNavPane: PropTypes.func.isRequired,
};

NavPane.defaultProps = {
  activePane: null,
  goToRoot: null,
};

export default NavPane;
